/*
  Starlight Library — secure admin product importer
  Add this file to Shopify theme Assets and include it before </body>:
  {{ 'starlight-product-importer.js' | asset_url | script_tag }}
*/
(() => {
  "use strict";

  const CONFIG = {
    firebaseApiKey: "AIzaSyCyj-BcLr_027LoCTD5UN4Olf0XaHDF2b8",
    importerEndpoint: "https://us-central1-bookclubchat-752af.cloudfunctions.net/adminProductImporter",
  };

  let idToken = sessionStorage.getItem("starlightAdminIdToken") || "";
  let product = null;
  let availableCollections = [];
  let defaultCollectionHandle = "up-coming-books";
  let duplicateMatches = [];
  let mounted = false;

  const el = (tag, attrs = {}, children = []) => {
    const node = document.createElement(tag);
    Object.entries(attrs).forEach(([key, value]) => {
      if (key === "class") node.className = value;
      else if (key === "html") node.innerHTML = value;
      else if (key.startsWith("on") && typeof value === "function") node.addEventListener(key.slice(2).toLowerCase(), value);
      else if (value !== undefined && value !== null) node.setAttribute(key, value);
    });
    (Array.isArray(children) ? children : [children]).forEach((child) => {
      if (child === null || child === undefined) return;
      node.append(child.nodeType ? child : document.createTextNode(String(child)));
    });
    return node;
  };

  function styles() {
    if (document.getElementById("sl-importer-style")) return;
    document.head.append(el("style", { id: "sl-importer-style", html: `
      .slpi-backdrop{position:fixed;inset:0;z-index:2147483646;background:rgba(0,8,28,.72);backdrop-filter:blur(8px);display:grid;place-items:center;padding:16px;font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}
      .slpi-card{width:min(720px,100%);max-height:min(850px,94vh);overflow:auto;background:linear-gradient(150deg,#071838,#020b22);color:#fff;border:1px solid rgba(255,255,255,.14);border-radius:24px;box-shadow:0 28px 90px rgba(0,0,0,.45);padding:24px}
      .slpi-head{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;margin-bottom:20px}.slpi-brand{font-size:12px;letter-spacing:.16em;text-transform:uppercase;color:#a8c2ff}.slpi-title{font-size:24px;line-height:1.15;margin:6px 0 5px}.slpi-sub{color:#b9c6df;font-size:14px;margin:0}.slpi-close{border:0;background:rgba(255,255,255,.08);color:white;width:38px;height:38px;border-radius:50%;font-size:22px;cursor:pointer}
      .slpi-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}.slpi-full{grid-column:1/-1}.slpi-field{display:flex;flex-direction:column;gap:7px}.slpi-field label{font-size:12px;font-weight:700;color:#cad6ec}.slpi-field input,.slpi-field textarea,.slpi-field select{width:100%;box-sizing:border-box;border:1px solid rgba(255,255,255,.16);border-radius:13px;background:rgba(255,255,255,.07);color:#fff;padding:12px 13px;font:inherit;outline:none}.slpi-field textarea{min-height:150px;resize:vertical}.slpi-field input:focus,.slpi-field textarea:focus,.slpi-field select:focus{border-color:#6ea3ff;box-shadow:0 0 0 3px rgba(67,133,255,.18)}.slpi-field option{color:#111}
      .slpi-actions{display:flex;gap:10px;justify-content:flex-end;margin-top:20px;flex-wrap:wrap}.slpi-btn{border:0;border-radius:13px;padding:12px 18px;font-weight:800;cursor:pointer}.slpi-primary{background:#fff;color:#051335}.slpi-secondary{background:rgba(255,255,255,.09);color:#fff;border:1px solid rgba(255,255,255,.13)}.slpi-btn:disabled{opacity:.55;cursor:wait}
      .slpi-status{margin:14px 0 0;border-radius:12px;padding:11px 13px;font-size:13px;background:rgba(255,255,255,.07);color:#cfdbef}.slpi-error{background:rgba(210,52,75,.18);color:#ffd5dc}.slpi-success{background:rgba(44,183,124,.17);color:#c9ffe8}.slpi-cover{width:98px;height:150px;object-fit:contain;background:#fff;border-radius:10px;float:right;margin-left:14px}.slpi-note{font-size:12px;color:#9eb0ce;line-height:1.5;margin-top:10px}
      @media(max-width:620px){.slpi-card{padding:18px;border-radius:19px}.slpi-grid{grid-template-columns:1fr}.slpi-full{grid-column:auto}.slpi-title{font-size:21px}}
    ` }));
  }

  function shell(title, subtitle) {
    styles();
    const backdrop = el("div", { class: "slpi-backdrop" });
    const body = el("div");
    const card = el("div", { class: "slpi-card" }, [
      el("div", { class: "slpi-head" }, [
        el("div", {}, [el("div", { class: "slpi-brand" }, "Starlight Library Admin"), el("h2", { class: "slpi-title" }, title), el("p", { class: "slpi-sub" }, subtitle)]),
        el("button", { class: "slpi-close", type: "button", "aria-label": "Close", onclick: () => backdrop.remove() }, "×"),
      ]),
      body,
    ]);
    backdrop.append(card);
    backdrop.addEventListener("click", (event) => { if (event.target === backdrop) backdrop.remove(); });
    document.body.append(backdrop);
    return { backdrop, body };
  }

  async function login(email, password) {
    const response = await fetch(`https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${encodeURIComponent(CONFIG.firebaseApiKey)}`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password, returnSecureToken: true }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error?.message === "INVALID_LOGIN_CREDENTIALS" ? "Incorrect email or password." : (data.error?.message || "Unable to sign in."));
    idToken = data.idToken;
    sessionStorage.setItem("starlightAdminIdToken", idToken);
  }

  async function api(body) {
    const response = await fetch(CONFIG.importerEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
      body: JSON.stringify(body),
    });
    const data = await response.json().catch(() => ({}));
    if (response.status === 401) { idToken = ""; sessionStorage.removeItem("starlightAdminIdToken"); }
    if (!response.ok) throw new Error(data.error || "Something went wrong.");
    return data;
  }

  function status(container, message, type = "") {
    container.innerHTML = "";
    if (message) container.append(el("div", { class: `slpi-status ${type ? `slpi-${type}` : ""}` }, message));
  }

  function loginView() {
    const { backdrop, body } = shell("Admin sign in", "Sign in with your Firebase administrator account to add products securely.");
    const email = el("input", { type: "email", autocomplete: "username", placeholder: "Admin email" });
    const password = el("input", { type: "password", autocomplete: "current-password", placeholder: "Password" });
    const message = el("div");
    const button = el("button", { class: "slpi-btn slpi-primary", type: "submit" }, "Log in");
    const form = el("form", {}, [
      el("div", { class: "slpi-grid" }, [
        el("div", { class: "slpi-field slpi-full" }, [el("label", {}, "Email"), email]),
        el("div", { class: "slpi-field slpi-full" }, [el("label", {}, "Password"), password]),
      ]), message, el("div", { class: "slpi-actions" }, button),
    ]);
    form.addEventListener("submit", async (event) => {
      event.preventDefault(); button.disabled = true; status(message, "Signing in…");
      try { await login(email.value.trim(), password.value); backdrop.remove(); linkView(); }
      catch (error) { status(message, error.message, "error"); }
      finally { button.disabled = false; }
    });
    body.append(form); email.focus();
  }

  function linkView() {
    const { backdrop, body } = shell("Paste the publisher link", "Penguin UK and Penguin Random House remain separate. Waterstones product pages are also supported.");
    const url = el("input", { type: "url", placeholder: "Paste a Penguin or Waterstones product link", required: "required" });
    const message = el("div");
    const button = el("button", { class: "slpi-btn slpi-primary", type: "submit" }, "Search product");
    const form = el("form", {}, [
      el("div", { class: "slpi-field" }, [el("label", {}, "Product link"), url]),
      message,
      el("div", { class: "slpi-actions" }, [el("button", { class: "slpi-btn slpi-secondary", type: "button", onclick: () => { sessionStorage.removeItem("starlightAdminIdToken"); idToken = ""; backdrop.remove(); loginView(); } }, "Change account"), button]),
    ]);
    form.addEventListener("submit", async (event) => {
      event.preventDefault(); button.disabled = true; status(message, "Searching the publisher page…");
      try {
        const data = await api({ action: "preview", url: url.value.trim() });
        product = data.product;
        availableCollections = Array.isArray(data.collections) ? data.collections : [];
        defaultCollectionHandle = data.defaultCollectionHandle || "up-coming-books";
        duplicateMatches = Array.isArray(data.duplicateMatches) ? data.duplicateMatches : [];
        backdrop.remove();
        previewView();
      }
      catch (error) { status(message, error.message, "error"); if (!idToken) { setTimeout(() => { backdrop.remove(); loginView(); }, 900); } }
      finally { button.disabled = false; }
    });
    body.append(form); url.focus();
  }

  function previewView() {
    const { backdrop, body } = shell("Review Shopify product", "Check the details before creating the product. It will be created as a draft by default.");
    const fields = {};
    const definitions = [
      ["title", "Book title"], ["author", "Author"], ["isbn", "ISBN"], ["publishedDate", "Published date", "date"],
      ["publisher", "Publisher"], ["pageCount", "Number of pages"], ["dimensionsCm", "Dimensions in cm"], ["interestAge", "Interest age"],
      ["language", "Language"], ["imageUrl", "Cover image URL"],
    ];
    if (duplicateMatches.length) {
      const duplicateBox = el("div", { class: "slpi-status slpi-error" });
      duplicateBox.append(el("strong", {}, duplicateMatches.length === 1
        ? "This product may already be on your website."
        : "Possible duplicate products were found on your website."));
      duplicateMatches.forEach((match) => {
        const row = el("div", { style: "margin-top:10px;padding-top:10px;border-top:1px solid rgba(255,255,255,.14)" }, [
          el("div", {}, `${match.title}${match.reason ? ` — ${match.reason}` : ""}`),
          el("div", { class: "slpi-actions", style: "justify-content:flex-start;margin-top:8px" }, [
            match.storefrontUrl ? el("a", { class: "slpi-btn slpi-secondary", href: match.storefrontUrl, target: "_blank", rel: "noopener" }, "View product") : null,
            match.adminUrl ? el("a", { class: "slpi-btn slpi-secondary", href: match.adminUrl, target: "_blank", rel: "noopener" }, "Open in Shopify") : null,
          ]),
        ]);
        duplicateBox.append(row);
      });
      body.append(duplicateBox);
    }

    const grid = el("div", { class: "slpi-grid" });
    const coverPreview = el("img", {
      class: "slpi-cover",
      src: product.imageUrl || "",
      alt: "Book cover preview",
      style: product.imageUrl ? "" : "display:none",
    });
    grid.append(el("div", { class: "slpi-full" }, coverPreview));
    definitions.forEach(([key, label, type = "text"]) => {
      fields[key] = el("input", { type, value: product[key] || "" });
      grid.append(el("div", { class: `slpi-field ${key === "imageUrl" ? "slpi-full" : ""}` }, [el("label", {}, label), fields[key]]));
    });
    fields.imageFile = el("input", { type: "file", accept: "image/png,image/jpeg,image/webp" });
    grid.append(el("div", { class: "slpi-field slpi-full" }, [
      el("label", {}, "Choose product image manually (optional)"),
      fields.imageFile,
      el("div", { class: "slpi-note" }, "Your selected image replaces the publisher cover and is resized to 975 × 1500 px."),
    ]));

    let manualImageDataUrl = "";
    fields.imageFile.addEventListener("change", () => {
      const file = fields.imageFile.files?.[0];
      manualImageDataUrl = "";
      if (!file) {
        coverPreview.src = fields.imageUrl.value || product.imageUrl || "";
        coverPreview.style.display = coverPreview.src ? "block" : "none";
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        fields.imageFile.value = "";
        alert("Choose an image under 10 MB.");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        manualImageDataUrl = String(reader.result || "");
        coverPreview.src = manualImageDataUrl;
        coverPreview.style.display = "block";
      };
      reader.readAsDataURL(file);
    });

    fields.imageUrl.addEventListener("input", () => {
      if (manualImageDataUrl) return;
      coverPreview.src = fields.imageUrl.value.trim();
      coverPreview.style.display = coverPreview.src ? "block" : "none";
    });

    fields.synopsis = el("textarea", {}, product.synopsis || "");
    grid.append(el("div", { class: "slpi-field slpi-full" }, [el("label", {}, "Synopsis"), fields.synopsis]));
    fields.format = el("select", {}, [el("option", { value: "Paperback" }, "Paperback"), el("option", { value: "Hardback" }, "Hardback")]);
    fields.format.value = product.format || "Paperback";
    fields.price = el("input", {
      type: "number",
      min: "0",
      step: "0.001",
      value: String(product.defaultPrice || "0"),
      placeholder: "Shopify price"
    });
    fields.status = el("select", {}, [el("option", { value: "DRAFT" }, "Draft"), el("option", { value: "ACTIVE" }, "Active")]);
    fields.collection = el("select");
    fields.collection.append(el("option", { value: "" }, "No collection"));
    availableCollections.forEach((collection) => {
      fields.collection.append(el("option", { value: collection.handle }, collection.title));
    });
    fields.collection.value = availableCollections.some((collection) => collection.handle === defaultCollectionHandle)
      ? defaultCollectionHandle
      : "";

    grid.append(el("div", { class: "slpi-field" }, [el("label", {}, "Book cover type"), fields.format]));
    grid.append(el("div", { class: "slpi-field" }, [
      el("label", {}, "Price"),
      fields.price,
      product.sourcePriceGbp
        ? el("div", { class: "slpi-note" }, `Publisher price: £${Number(product.sourcePriceGbp).toFixed(2)}`)
        : null
    ]));
    grid.append(el("div", { class: "slpi-field" }, [el("label", {}, "Shopify status"), fields.status]));
    grid.append(el("div", { class: "slpi-field" }, [el("label", {}, "Shopify collection"), fields.collection]));
    const message = el("div");
    const create = el("button", { class: "slpi-btn slpi-primary", type: "button" }, "Create Shopify product");
    create.addEventListener("click", async () => {
      create.disabled = true; status(message, "Resizing the cover to 975 × 1500 and creating the product…");
      const edited = { ...product };
      Object.keys(fields).forEach((key) => {
        if (!["price", "status", "imageFile", "collection"].includes(key)) edited[key] = fields[key].value.trim();
      });
      if (manualImageDataUrl) edited.imageDataUrl = manualImageDataUrl;
      try {
        const data = await api({
          action: "create",
          product: edited,
          price: fields.price.value || "0",
          status: fields.status.value,
          preorderCollectionHandle: fields.collection.value,
        });
        body.innerHTML = "";
        body.append(el("div", { class: "slpi-status slpi-success", html: `<strong>${data.created.title}</strong><br>Created with ${data.created.format}, inventory 99, and a 975 × 1500 cover.` }));
        if (data.created.collection?.title) {
          body.append(el("p", { class: "slpi-note" }, `Added to collection: ${data.created.collection.title}.`));
        }
        if (data.created.status === "ACTIVE") {
          const channels = Array.isArray(data.created.publishedChannels)
            ? data.created.publishedChannels
            : [];
          const expectedChannelsPublished =
            data.created.publishedToOnlineStore && data.created.publishedToPointOfSale;
          body.append(el("p", { class: "slpi-note" }, expectedChannelsPublished
            ? `Published successfully to: ${channels.join(", ") || "Online Store and Point of Sale"}.`
            : `Product created, but one or more sales channels could not be activated: ${data.created.publicationWarning || "Check Online Store and Point of Sale publishing in Shopify."}`));
        }
        body.append(el("p", { class: "slpi-note" }, data.created.preorder.reason));
        body.append(el("div", { class: "slpi-actions" }, [
          el("button", { class: "slpi-btn slpi-secondary", type: "button", onclick: () => { backdrop.remove(); linkView(); } }, "Add another"),
          el("a", { class: "slpi-btn slpi-primary", href: data.created.adminUrl, target: "_blank", rel: "noopener" }, "Open in Shopify"),
        ]));
      } catch (error) { status(message, error.message, "error"); create.disabled = false; }
    });
    body.append(grid, el("p", { class: "slpi-note" }, "Dimensions remain blank when the publisher does not provide them. Inventory will be set to 99. Essential Preorder must still be attached inside its app unless the app vendor provides a private API."), message, el("div", { class: "slpi-actions" }, [el("button", { class: "slpi-btn slpi-secondary", type: "button", onclick: () => { backdrop.remove(); linkView(); } }, "Back"), create]));
  }

  function open() { idToken ? linkView() : loginView(); }
  window.StarlightProductImporter = { open };

  // Detect the structured response returned by starlightAiChat after “add product”.
  if (!mounted && window.fetch) {
    mounted = true;
    const nativeFetch = window.fetch.bind(window);
    window.fetch = async (...args) => {
      const response = await nativeFetch(...args);
      try {
        const url = String(args[0]?.url || args[0] || "");
        if (/starlightAiChat/i.test(url)) {
          const data = await response.clone().json();
          if (data?.action === "admin_product_import") setTimeout(open, 0);
        }
      } catch (_) {}
      return response;
    };
  }
})();